const o = {
  // 搜索栏常用控件
  fleet: {
    label: "车队长",
    keyName: "fleet",
    placeholder: "请选择车队长",
    type: "select",
  },
  date: {
    label: "日期",
    keyName: "date",
    placeholder: "请选择日期",
    type: "date",
  },
  month: {
    label: "月份",
    keyName: "month",
    placeholder: "请选择月份",
    type: "month",
  },
  license: {
    label: "车牌号",
    keyName: "license",
    placeholder: "请填写车牌号",
    type: "text",
  },
  // 详情页常用控件
  ZhuangHuoRiQi: {
    label: "装货日期",
    keyName: "predict_loading_date",
    err: "请选择装货日期",
    type: "date",
  },
  XieHuoRiQi: {
    label: "卸货日期",
    keyName: "predict_unloading_date",
    err: "请选择卸货日期",
    type: "date",
  },
}

export default o